import { MessageSquareText } from 'lucide-react'
import Tooltip from 'rc-tooltip'
import { MouseEvent } from 'react'
import { inboundNotificationsService } from 'src/services/inbound-notifications.service'
import classes from './inbound-sms-event-badge.module.scss'

const FALLBACK_TOOLTIP = 'Unread client SMS reply'

type Props = {
  eventId: string
  preview?: string
  onOpenCenter?: (eventId: string) => void
}

function stopBubble(event: MouseEvent) {
  event.stopPropagation()
}

export function InboundSmsEventBadge({ eventId, preview, onOpenCenter }: Props) {
  const tooltipText = preview ?? FALLBACK_TOOLTIP

  const handleClick = async (event: MouseEvent) => {
    stopBubble(event)
    await inboundNotificationsService.bulkRead(eventId)
    onOpenCenter?.(eventId)
  }

  return (
    <span className={classes.badgeWrapper} onClick={stopBubble} onMouseDown={stopBubble}>
      <Tooltip
        key={tooltipText}
        destroyTooltipOnHide
        mouseEnterDelay={0.1}
        overlay={<span className={classes.tooltipText}>{tooltipText}</span>}
        overlayClassName={classes.tooltipOverlay}
      >
        <span className={classes.badge} onClick={handleClick} role="button" tabIndex={0} aria-label={tooltipText}>
          <MessageSquareText size={14} />
        </span>
      </Tooltip>
    </span>
  )
}
